import React from 'react';
import T from 'prop-types';

import ArrowChange from '../../../../components/ArrowChange';

import { numberToHumanChart } from '../../../../utils/formatter';

const MetricStats = ({ change, total, type, params, metric, zeroValue = '0%' }) => (
  <div className="metric-stats-wrapper">
    <ArrowChange
      change={change || 0}
      iconPosition="behind"
      upArrowClass="hicon-positive-arrow"
      downArrowClass="hicon-negative-arrow"
      precision={3}
      className="metric-stats-change-arrow"
      withZeroIcon
      zeroValue={zeroValue}
      {...params}
    />
    <div className="metric-stats-total">
      {metric === 'arpu' && '$'}
      {typeof total === 'string' ? total : numberToHumanChart(total)} ({type})
    </div>
  </div>
);

MetricStats.propTypes = {
  change: T.number,
  total: T.number,
  type: T.string,
  metric: T.string,
  params: T.object,
  zeroValue: T.string,
};

export default MetricStats;
